// Node Modules
import { RichText } from 'prismic-reactjs';
import { useEffect } from 'react';
// Component
import Container from '@/components/global-components/Container';
import Reviews from '@/components/global-components/reviews/Reviews'
import Carousel from '@/components/global-components/carousel/Carousel';
import { carousel } from '@/scripts/constants';

// Themes
import theme from '@/themes/index';

const UniversityBody = ({
  content: {
    logo,
    title,
    description,
    universityReviews,
    images,
  },
  isMobile,
  isDesktop,
}) => {
  useEffect(() => {
    document.title = title;
  });

  return (
    <>
      <section className='logo'>
        <Container 
          style={{
            display: 'flex', 
            justifyContent: isDesktop ? 'left' : 'center',
          }}
        >
          
          <img src={logo?.url}/>
        </Container>
      </section>
      <section className='information'>
        <Container>
          <h1>{title}</h1>
          <RichText render={description} />
        </Container>
      </section>
      <section className='carousel'>
        <Container 
          style={{
            display: 'flex', 
            justifyContent: isDesktop ? 'left' : 'center',
          }}
        >
          { images && images.length > 0 && images[0].unimage &&
          <Carousel
            cellSpacing={10}
            showPaging={false}
            transitionMode={carousel.FADE}
            autoplay={true}
            slidesToShow={2}
            autoplayInterval={5 * 1000}
            wrapAround={true}
          >
            {images && images.map(
              ({
                unimage: {
                  url,
                  title,
                },
              }) => (
                <img
                  key={2}
                  src={url}
                  title={title}
                />
              )
            )}
            
          </Carousel>}
        </Container>
      </section>
      {universityReviews && <section className='reviews'>
        <Container>
          <Reviews 
            content={universityReviews} 
            showHeader={false} 
            showButtons={false} 
            isMobile={isMobile} 
          />
        </Container>
      </section> }
      <style jsx>{`
        section.logo,
        section.information,
        section.reviews,
        section.carousel {
          padding: 1rem 0;
        }

        section.carousel img {
          width: 100%;
          height: 600px;
          object-fit: cover;
        }

        section.logo {
          padding-top: 8rem;
        }

        section.logo img {
          max-width: 13.625rem;
          max-height: 9.8125rem;
        }

        section.information {
          display: flex;
          flex-direction: column;
          text-align: center;
          padding-bottom: 3rem;
        }

        section.information h3 {
          margin-block-start: 0;
          margin-block-end: 0;
          line-height: 1.875rem;
        }
        section.information p a {
          line-height: inherit;
          text-decoration: none;
          color: #00E065;
        }

        section.reviews {
          padding: 3rem 0 8rem;
        }

        @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
          section.information h3 {
            margin-block-end: 1rem;
          }
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          section.logo,
          section.information,
          section.reviews {
            padding: 0;
          }

          section.logo {
            padding: 8rem 0 1rem;
          }

          section.information {
            padding: 1rem 0 2rem;
            text-align: left;
          }

          section.information h3 {
            line-height: 5.375rem;
            margin-block-end: 0;
          }

          section.reviews {
            padding: 5rem 0 5.813rem;
          }
        }
      `}</style>
      <style global jsx>{`
        section.information p {
          margin-block-end: 0;
        }

        section.information p a {
          line-height: inherit;
          text-decoration: none;
          color: #00E065;
        }
      `}</style>
    </>
  );
};

export default UniversityBody;